import { ChevronsRight } from 'lucide-react'

import {
  BorderedTooltipContent,
  TooltipPortal,
  TooltipRoot,
  TooltipTrigger,
} from '@/components/ui'

interface CollapseEdgeProps {
  onClick: () => void
}

// Desktop-only collapse affordance. A small chevron tab pinned to the
// inner-left edge of the sidebar, positioned via absolute layout
// relative to its caller's `relative` container. Always visible (no
// hover-to-reveal) — hover only intensifies the styling.
//
// Stacks under the ResizeHandle (z-40 at the very edge) so resize and
// collapse don't fight for the same pixels. Mobile keeps the existing
// MobileBackdrop tap-to-close pattern; this is hidden below xl.
export default function CollapseEdge({ onClick }: CollapseEdgeProps) {
  return (
    <TooltipRoot delayDuration={200}>
      <TooltipTrigger asChild>
        <button
          type="button"
          aria-label="Collapse chat"
          onClick={onClick}
          className="group absolute left-0 top-full z-30 mt-2 cursor-pointer"
        >
          <span className="flex h-7 items-center justify-center rounded-r-md border border-l-0 bg-popover px-1 text-muted-foreground shadow-sm transition-colors group-hover:bg-accent group-hover:text-foreground">
            <ChevronsRight className="h-3.5 w-3.5" />
          </span>
        </button>
      </TooltipTrigger>
      <TooltipPortal>
        <BorderedTooltipContent side="right">
          Collapse chat
        </BorderedTooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  )
}
